/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15M14 15C14 13.8954 13.1046 13 12 13M14 15V15C15.9209 15 17.7631 15.7631 19.1213 17.1213L20 18M10 15C10 13.8954 10.8954 13 12 13M10 15V15C8.07913 15 6.23694 15.7631 4.87868 17.1213L4 18M12 13V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H20M2 12C2 6.47715 6.47715 2 12 2M2 12H4M12 2V4M19.0004 5L18 6M5 5L6 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 2C6.47715 2 2 6.47715 2 12C2 14.2514 2.74401 16.329 3.99958 18.0004L4.87868 17.1213C6.23694 15.7631 8.07913 15 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15C15.9209 15 17.7631 15.7631 19.1213 17.1213L20.0004 18.0004C21.256 16.329 22 14.2514 22 12C22 6.47715 17.5228 2 12 2Z"
				fill="currentColor"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H20M2 12C2 6.47715 6.47715 2 12 2M2 12H4M12 2V4M4 18L5.23223 16.7678C6.36411 15.6359 7.89928 15 9.5 15V15M20 18L18.7678 16.7678C17.6359 15.6359 16.1007 15 14.5 15V15M19.0004 5L18 6M5 5L6 6M12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13ZM12 13V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9999 1.25C6.06282 1.25 1.24988 6.06294 1.24988 12C1.24988 13.977 1.78357 15.8294 2.71474 17.4209C3.67199 16.3951 4.24997 15.7793 4.94281 15.3314C5.56386 14.9299 6.24667 14.6332 6.96395 14.4531C7.77398 14.2498 8.62947 14.2499 10.0637 14.25L10.1455 14.25C10.3502 13.7443 10.7557 13.3414 11.2632 13.1401C11.2546 13.0947 11.2501 13.0479 11.2501 13V9C11.2501 8.58579 11.5859 8.25 12.0001 8.25C12.4143 8.25 12.7501 8.58579 12.7501 9V13C12.7501 13.0479 12.7456 13.0947 12.737 13.1401C13.2445 13.3414 13.65 13.7443 13.8547 14.25L13.9366 14.25C15.3709 14.2499 16.2264 14.2498 17.0364 14.4531C17.7537 14.6332 18.4365 14.9299 19.0576 15.3314C19.7503 15.7793 20.3282 16.395 21.2852 17.4205C22.2163 15.8291 22.7499 13.9769 22.7499 12C22.7499 6.06294 17.9369 1.25 11.9999 1.25ZM20.4165 18.6882L20.2983 18.5615C19.2238 17.4102 18.77 16.9317 18.2432 16.5911C17.7601 16.2788 17.2291 16.0481 16.6712 15.908C16.0661 15.7561 15.4107 15.7501 13.8547 15.75C13.558 16.483 12.8395 17 12.0001 17C11.1608 17 10.4422 16.483 10.1455 15.75C8.58962 15.7501 7.9342 15.7561 7.32918 15.908C6.7713 16.0481 6.24022 16.2788 5.75718 16.5911C5.23038 16.9317 4.77661 17.4102 3.70205 18.5615L3.58349 18.6885C5.55295 21.1634 8.59114 22.75 11.9999 22.75C15.4088 22.75 18.4471 21.1633 20.4165 18.6882ZM12.7501 4C12.7501 3.58579 12.4143 3.25 12.0001 3.25C11.5859 3.25 11.2501 3.58579 11.2501 4V5.33333C11.2501 5.74755 11.5859 6.08333 12.0001 6.08333C12.4143 6.08333 12.7501 5.74755 12.7501 5.33333V4ZM7.19712 6.13634C6.90423 5.84344 6.42935 5.84344 6.13646 6.13634C5.84357 6.42923 5.84357 6.9041 6.13646 7.197L7.02535 8.08589C7.31824 8.37878 7.79311 8.37878 8.08601 8.08589C8.3789 7.79299 8.3789 7.31812 8.08601 7.02523L7.19712 6.13634ZM17.8638 7.197C18.1567 6.9041 18.1567 6.42923 17.8638 6.13634C17.5709 5.84344 17.096 5.84344 16.8031 6.13634L15.9142 7.02523C15.6213 7.31812 15.6213 7.79299 15.9142 8.08589C16.2071 8.37878 16.682 8.37878 16.9749 8.08589L17.8638 7.197ZM4.00012 11.25C3.58591 11.25 3.25012 11.5858 3.25012 12C3.25012 12.4142 3.58591 12.75 4.00012 12.75H5.33346C5.74767 12.75 6.08346 12.4142 6.08346 12C6.08346 11.5858 5.74767 11.25 5.33346 11.25H4.00012ZM18.6668 11.25C18.2526 11.25 17.9168 11.5858 17.9168 12C17.9168 12.4142 18.2526 12.75 18.6668 12.75H20.0001C20.4143 12.75 20.7501 12.4142 20.7501 12C20.7501 11.5858 20.4143 11.25 20.0001 11.25H18.6668Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 7.89936 19.5318 4.3752 16 2.83209M22 12H20M2 12C2 6.47715 6.47715 2 12 2V4M2 12H4M20 18L18.7678 16.7678C17.6359 15.6359 16.1007 15 14.5 15M7 15H9.5M19.0004 5L18 6M5 5L6 6M12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13ZM12 13V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H20M2 12C2 6.47715 6.47715 2 12 2M2 12H4M12 2V4M4 18L5.23223 16.7678C6.36411 15.6359 7.89928 15 9.5 15V15M20 18L18.7678 16.7678C17.6359 15.6359 16.1007 15 14.5 15V15M19.0004 5L18 6M5 5L6 6M12 13C10.8954 13 10 13.8954 10 15C10 16.1046 10.8954 17 12 17C13.1046 17 14 16.1046 14 15C14 13.8954 13.1046 13 12 13ZM12 13V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V5.33333C11.25 5.74755 11.5858 6.08333 12 6.08333C12.4142 6.08333 12.75 5.74755 12.75 5.33333V4ZM7.197 6.13634C6.9041 5.84344 6.42923 5.84344 6.13634 6.13634C5.84344 6.42923 5.84344 6.9041 6.13634 7.197L7.02523 8.08589C7.31812 8.37878 7.79299 8.37878 8.08589 8.08589C8.37878 7.79299 8.37878 7.31812 8.08589 7.02523L7.197 6.13634ZM17.8637 7.197C18.1566 6.9041 18.1566 6.42923 17.8637 6.13634C17.5708 5.84344 17.0959 5.84344 16.803 6.13634L15.9141 7.02523C15.6212 7.31812 15.6212 7.79299 15.9141 8.08589C16.207 8.37878 16.6819 8.37878 16.9748 8.08589L17.8637 7.197ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9V13C11.25 13.0479 11.2545 13.0948 11.2631 13.1402C10.7557 13.3414 10.3502 13.7443 10.1455 14.25H10.0639C8.62963 14.2499 7.77413 14.2498 6.96411 14.4532C6.24683 14.6332 5.56402 14.9299 4.94296 15.3314C4.25015 15.7794 3.67217 16.3951 2.71497 17.4208C4.58013 20.6087 8.04007 22.75 12.0001 22.75C15.9603 22.75 19.4203 20.6086 21.2855 17.4206C20.3284 16.395 19.7505 15.7793 19.0577 15.3315C18.4367 14.93 17.7538 14.6332 17.0366 14.4532C16.2265 14.2498 15.371 14.2499 13.9368 14.25H13.8547C13.65 13.7443 13.2445 13.3413 12.7369 13.1401C12.7455 13.0947 12.75 13.0479 12.75 13V9ZM4 11.25C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H5.33333C5.74755 12.75 6.08333 12.4142 6.08333 12C6.08333 11.5858 5.74755 11.25 5.33333 11.25H4ZM18.6667 11.25C18.2525 11.25 17.9167 11.5858 17.9167 12C17.9167 12.4142 18.2525 12.75 18.6667 12.75H20C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25H18.6667Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
